import React, { useEffect, useState } from 'react';
import styled from 'styled-components/native';
import { BasicText, FlexBlock, FlexBlockWrapped, FlexElement, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading } from '../Styles';
import { COLORS } from '../../WasteTheme';
import _ from 'lodash';
import Icon from './Icon';
import { TouchableOpacity, View } from 'react-native';
import withHover from './withHover';
import Util from './Util';

export function MetricStack({children, title="", defaultSelectedTitle="", flexGrow=1, flexBasis=null, style={}, allowFavourites=false}){
    const [currentTitle, setTitle] = useState(title);
    const [selectedChild, setSelectedChild] = useState(0);
    const [showOptions, setShowOptions] = useState(false);
    const [options, setOptions] = useState([]);
    const [isFavourite, setIsFavourite] = useState(-1);

    allowFavourites = false;

    //need to actually inspect all titles, but this doesn't seem to work.
    const allTitles = React.Children.map(children, (child)=>child.props.title).join("");
    if(flexBasis == null){
        flexBasis = 0;
    }

    useEffect( ()=>{
        const newOptions = _.sortBy(React.Children.map(children, (child, idx)=>{
            return {value: idx, label: child.props.title};
        }), "label");
        setOptions( newOptions );

        if (defaultSelectedTitle){
            const newIdx = _.findIndex(newOptions, (o)=>o.label == defaultSelectedTitle);
            setSelectedChild(newIdx);
        }
    }, [children, allTitles]);

    useEffect( ()=>{
        const child = React.Children.toArray(children)[selectedChild];
        if (child && child.props){
            setTitle(child.props.title);
        }
    }, [selectedChild, children]);

    const openOptions = ()=>{
        setShowOptions(!showOptions);
    }

    const openOption = (idx)=>{
        setShowOptions(false);
        setSelectedChild(idx);
    }

    const setFavourite = (e)=>{
        setIsFavourite(selectedChild);
    }

    const OptionsBlockOuter = styled(FlexBlock)`
        background-color: white;
        position: absolute;
        width: 90%;
        left: 2.5%;
        top: -10px;
        z-index: 100;
        padding: 0px;
        display: flex;
        flex-direction: column;
        border: 1px solid #cccccc;
        padding: 4px;
    `;

    const ShiteButton = withHover(styled.View`
        background-color: ${props=>props.hovered ? '#f1f1f1' : '#ffffff' };
        padding: 2px;
    `);

    const MenuText = styled(BasicText)`
        font-size: 14px;
        text-transform: uppercase;
    `;

    const optionsBlock = <OptionsBlockOuter>
        {options.map( (o)=><TouchableOpacity key={o.value} onPress={()=>openOption(o.value)}><ShiteButton><MenuText key={o.value}>{o.label}</MenuText></ShiteButton></TouchableOpacity>)}
    </OptionsBlockOuter>;

    const childrenArray = React.Children.toArray(children);

    const dropdownIcon = "chevron-down"; //"ellipsis-h";
    
    return <ShinyBlockOuter flexBasis={flexBasis} style={{...style}}>
        <ShinyHeading hover={childrenArray.length > 1}>
            <TouchableOpacity onPress={childrenArray.length > 1 ? openOptions : null} style={{flexDirection: "row", justifyContent: "space-between", flexBasis: "100%"}}>
                <MetricStackTitle>{currentTitle}</MetricStackTitle>
                { childrenArray.length > 1?
                <FlexBlock flexDirection="row">
                    <Icon icon={dropdownIcon} fType={"fal"} colour={"white"} size={24} onClick={openOptions}/>
                    { allowFavourites ? <Icon icon={"star"} fType={"fal"} colour={isFavourite == selectedChild ? "#ffff" : "#fff4"} size={24} onClick={setFavourite} title="Set As Favorite"/> : null }
                </FlexBlock>
                : null }
            </TouchableOpacity>
        </ShinyHeading>
        <ShinyBody>
            { showOptions ? optionsBlock : null }
            {childrenArray[selectedChild]}
        </ShinyBody>
  </ShinyBlockOuter>;
}

export function Metric({thekey = undefined, title = undefined, subtitle = undefined, value, icon, delta = undefined, colour = "#cccccc", children = null, categoryName="", style={}, supertitle = undefined, superPosition = "right"}){
    const ValueOuter = styled(FlexBlock)`
        display: flex;
        justify-content: ${props => props.icon == undefined? "center" : "space-between"};
        padding: 10px;
        width: 100%;
    `;

    const ValueChange = styled(BasicText)`
        text-align: right;
        padding-right: 20px;
        color: ${ props=>props.negative ? COLORS.red : COLORS.blue };
        font-size: 16px;
        font-weight: bold;
    `;

    const ValueText = styled(BasicText)`
        font-size: 25px;
        font-weight: bold;
        color: #555555;
    `;

    return <View key={thekey} style={style}>
        {supertitle != undefined? <BasicText style={{textAlign: superPosition}}>{supertitle}</BasicText> : null}
        <ValueOuter icon={icon} style={{alignItems: "flex-end"}}>
            <ValueText>{value}</ValueText>
            { icon != undefined? <Icon icon={icon} colour={colour} size={36} style={{height: 36, width: 36, display: "flex", justifyContent: "center", alignItems: "center"}}/> : null}
        </ValueOuter>
        <FlexBlock style={{marginTop: 10, borderTopWidth: 1, borderTopColor: "#cccccc", paddingTop: 5}}>
            <BasicText style={{minHeight: 16}}>{subtitle}</BasicText>
            {children ? <FlexElement>{React.cloneElement(children, {title: title, subtitle: subtitle, categoryName: categoryName})}</FlexElement> : null}
            <FlexElement>{delta != undefined? <ValueChange negative={delta < 0}>{delta}</ValueChange> : null}</FlexElement>
        </FlexBlock>
    </View>;
}

const Metrics = ({data = {}, showDelta = true, children = undefined, categoryOrder = []}) => {
    const [metrics, setMetrics] = useState([]);

    useEffect(()=>{
        if(categoryOrder.length == 0){
            setMetrics(_.map(data, (items, categoryName)=>{
                return <MetricStack allowFavourites={true} key={categoryName} flexBasis={Util.isMobile()? "100%": "32%"}>
                    {_.map(items, (metric, idx)=>{
                        return <Metric key={categoryName+idx} thekey={categoryName+idx} title={metric.title} subtitle={metric.subtitle} value={metric.displayValue} icon={metric.icon} delta={showDelta ? metric.delta : null} colour={metric.colour} children={children} categoryName={categoryName}/>
                    })}
                </MetricStack>;
            }));
        } else {
            setMetrics(_.map(categoryOrder, (categoryName)=>{
                return <MetricStack allowFavourites={true} key={categoryName} flexBasis={Util.isMobile()? "100%": "32%"}>
                    {_.map(data[categoryName], (metric, idx)=>{
                        return <Metric key={categoryName+idx} thekey={categoryName+idx} title={metric.title} subtitle={metric.subtitle} value={metric.displayValue} icon={metric.icon} delta={showDelta ? metric.delta : null} colour={metric.colour} children={children} categoryName={categoryName}/>
                    })}
                </MetricStack>;
            }));
        }
    }, [data]);

    //mobile: justify-content: center;
    const MetricsSection = styled.View`
        z-index: 9999;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
        flex-basis: 100%;
    `;

    return <MetricsSection>
        {metrics}
    </MetricsSection>
}

export default Metrics;